import { INITIAL_STANDARD_RATE_DETAIL } from "us.collection.admin/constants";
import _ from "lodash";

/**
 * @description Get standard rate details for formik.
 * @param {Array} standardRates - Standard rates
 * @returns {Array} - standard rates details
 */
export const getStandardRateDetails = (
  standardRates: Array<typeof INITIAL_STANDARD_RATE_DETAIL>,
  rateId: number
): typeof INITIAL_STANDARD_RATE_DETAIL => {
  try {
    if (Array.isArray(standardRates)) {
      if (rateId == -1) {
        return INITIAL_STANDARD_RATE_DETAIL;
      } else {
        const selectedRate: any = _.find(standardRates, { rateId });

        if (selectedRate) {
          const { rate, effectiveDate } = selectedRate ?? {};

          return {
            ...INITIAL_STANDARD_RATE_DETAIL,
            rate: rate >= 0 ? rate : INITIAL_STANDARD_RATE_DETAIL.rate,
            effectiveDate: effectiveDate ? effectiveDate : INITIAL_STANDARD_RATE_DETAIL.effectiveDate,
          };
        } else {
          return INITIAL_STANDARD_RATE_DETAIL;
        }
      }
    } else {
      return INITIAL_STANDARD_RATE_DETAIL;
    }
  } catch (error) {
    return INITIAL_STANDARD_RATE_DETAIL;
  }
};
